// src/components/Dashboard.jsx
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// Dashboards for each role
import AdminDashboard from "../pages/Admin/AdminDashboard";
import AttempterDashboard from "../pages/Attempter/AttempterDashboard";
import ReviewerDashboard from "../pages/Reviewer/ReviewerDashboard";

function Dashboard() {
  const { user } = useSelector((state) => state.auth);
  if (!user) return <div>Loading...</div>;

  switch (user.role) {
    case 'admin':
      return <AdminDashboard />;
    case 'tasker':
      return <AttempterDashboard />;
    case 'reviewer':
      return <ReviewerDashboard />;
    default:
      return <div>Unknown role</div>;
  }
}

export default Dashboard;